export const MENU_ACTIVE_ITEM = "MENU_ACTIVE_ITEM"
export const MENU_TOGGLE = "MENU_TOGGLE"